module.exports = __webpack_public_path__ + "img/57-1.b4fcb3be.png";